import React from "react";
import { displayAttribute, useSourceLanguage } from "../i18n/LocalizedCopy";

export default function ProjectIllustration({ media, sizes = "(max-width: 650px) 100vw, 50vw" }) {
  useSourceLanguage();
  return <picture>
    {media.imageWebp ? <source type="image/webp" srcSet={`${media.imageSmall} 640w, ${media.imageWebp} 1672w`} sizes={sizes} /> : null}
    <img src={media.image} alt={displayAttribute(media.alt)} width="1672" height="941" loading="lazy" decoding="async" />
  </picture>;
}
